export class InvestableComponentParameters {
  public name: string;
  public weight: number;
  public min_weight: number;
  public max_weight: number;
  public alpha: number;
  public post_optim_weight: number;
  public investable_weight: number;

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.name       = data.name;
    this.weight     = data.weight;
    this.min_weight = data.min_weight;
    this.max_weight = data.max_weight;
    this.alpha      = data.alpha;
  }

  removeConstraints() {
    this.min_weight = 0;
    this.max_weight = 1;
  }

  fivePercents() {
    this.min_weight = this.weight-0.05>0 ? this.weight-0.05 : 0;
    this.max_weight = this.weight+0.05<1 ? this.weight+0.05 : 1;
  }

  checkWeightConstraints(): boolean {
    return (this.min_weight != 0) || (this.max_weight != 1);
  }
}